import { render, staticRenderFns } from "./app-adspace.vue?vue&type=template&id=057c06aa&"
import script from "./app-adspace.vue?vue&type=script&lang=js&"
export * from "./app-adspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports